var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab',{on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.title)+"  \n    "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }